import { ButtonHTMLAttributes } from 'react';
import { Button, ButtonProps } from '../../Button';

export function SubmitButton({
  children,
  ...rest
}: ButtonProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <Button {...rest} type="submit">
      {children}
    </Button>
  );
}
